"use strict";

var _interopRequireDefault3 = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault3(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault3(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault3(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault3(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault3(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault3(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault3(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault3(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault3(require("@babel/runtime/helpers/defineProperty"));

var _interopRequireDefault2 = _interopRequireDefault3(require("@babel/runtime/helpers/interopRequireDefault"));

var _autobindDecorator = _interopRequireDefault3(require("autobind-decorator"));

var _Checkbox = _interopRequireDefault3(require("../../Checkbox"));

var _classnames = _interopRequireDefault3(require("classnames"));

var _closest = _interopRequireDefault3(require("dom-helpers/query/closest"));

var _convertUnsafeMethod = _interopRequireDefault3(require("../../utils/convertUnsafeMethod"));

var _createId = _interopRequireDefault3(require("../../utils/createId"));

var _filterDOMProps = _interopRequireDefault3(require("../../utils/filterDOMProps"));

var _FocusManager = _interopRequireWildcard(require("../../utils/FocusManager"));

var _focusRing = _interopRequireDefault3(require("../../utils/focusRing"));

var _intl = require("../../utils/intl");

var _react = _interopRequireDefault3(require("react"));

var _TableCell = _interopRequireDefault3(require("./TableCell"));

var _class, _temp;

var intlMessages = {
  "cs-CZ": (0, _interopRequireDefault2["default"])(require("./../intl/cs-CZ.json"))["default"],
  "da-DK": (0, _interopRequireDefault2["default"])(require("./../intl/da-DK.json"))["default"],
  "de-DE": (0, _interopRequireDefault2["default"])(require("./../intl/de-DE.json"))["default"],
  "en-US": (0, _interopRequireDefault2["default"])(require("./../intl/en-US.json"))["default"],
  "es-ES": (0, _interopRequireDefault2["default"])(require("./../intl/es-ES.json"))["default"],
  "fi-FI": (0, _interopRequireDefault2["default"])(require("./../intl/fi-FI.json"))["default"],
  "fr-FR": (0, _interopRequireDefault2["default"])(require("./../intl/fr-FR.json"))["default"],
  "hu-HU": (0, _interopRequireDefault2["default"])(require("./../intl/hu-HU.json"))["default"],
  "it-IT": (0, _interopRequireDefault2["default"])(require("./../intl/it-IT.json"))["default"],
  "ja-JP": (0, _interopRequireDefault2["default"])(require("./../intl/ja-JP.json"))["default"],
  "ko-KR": (0, _interopRequireDefault2["default"])(require("./../intl/ko-KR.json"))["default"],
  "nb-NO": (0, _interopRequireDefault2["default"])(require("./../intl/nb-NO.json"))["default"],
  "nl-NL": (0, _interopRequireDefault2["default"])(require("./../intl/nl-NL.json"))["default"],
  "pl-PL": (0, _interopRequireDefault2["default"])(require("./../intl/pl-PL.json"))["default"],
  "pt-BR": (0, _interopRequireDefault2["default"])(require("./../intl/pt-BR.json"))["default"],
  "ru-RU": (0, _interopRequireDefault2["default"])(require("./../intl/ru-RU.json"))["default"],
  "sv-SE": (0, _interopRequireDefault2["default"])(require("./../intl/sv-SE.json"))["default"],
  "tr-TR": (0, _interopRequireDefault2["default"])(require("./../intl/tr-TR.json"))["default"],
  "uk-UA": (0, _interopRequireDefault2["default"])(require("./../intl/uk-UA.json"))["default"],
  "zh-CN": (0, _interopRequireDefault2["default"])(require("./../intl/zh-CN.json"))["default"],
  "zh-TW": (0, _interopRequireDefault2["default"])(require("./../intl/zh-TW.json"))["default"]
};
var formatMessage = (0, _intl.messageFormatter)(intlMessages);
var CELL_SELECTOR = '[role="gridcell"],[role="columnheader"],[role="rowheader"]';

var TableRow = (0, _convertUnsafeMethod["default"])(_class = (0, _focusRing["default"])(_class = (0, _autobindDecorator["default"])(_class = (_temp =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2["default"])(TableRow, _React$Component);

  function TableRow(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, TableRow);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(TableRow).call(this, props));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      focused: false
    });
    _this.rowId = (0, _createId["default"])();
    return _this;
  }

  (0, _createClass2["default"])(TableRow, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if ('focused' in nextProps) {
        this.setState({
          focused: nextProps.focused
        });
      }
    }
    /**
     * Sets focus to the table row DOM element or appropriate column.
     */

  }, {
    key: "focus",
    value: function focus() {
      if (this.row) {
        var _this$props = this.props,
            tableView = _this$props.tableView,
            isHeaderRow = _this$props.isHeaderRow; // tableView keeps track of the focusedColumnIndex when a cell receive focus

        if (tableView) {
          // if a focusedColumnIndex is defined, try to set focus to the appropriate cell.
          if (tableView.focusedColumnIndex !== null) {
            this.row.children[tableView.focusedColumnIndex].focus();
          }
        } // If no child of row receives focus:
        // - focus the first focusable descendant of the header row
        // - or focus the row itself.


        if (this.row.contains && !this.row.contains(document.activeElement)) {
          var focusable = isHeaderRow ? this.row.querySelector(_FocusManager.FOCUSABLE_ELEMENT_SELECTOR) : this.row;

          if (focusable) {
            focusable.focus();
          }
        }
      }
    }
  }, {
    key: "onCellClick",
    value: function onCellClick(column, isDoubleClick, e) {
      var rowIndex = null;

      if (this.props.collectionView) {
        var indexPath = this.props.collectionView.indexPathForComponent(this);
        rowIndex = indexPath && indexPath.index;
      }

      if (!isDoubleClick && this.props.onCellClick) {
        this.props.onCellClick(column, rowIndex);
      }

      if (isDoubleClick && this.props.onCellDoubleClick) {
        this.props.onCellDoubleClick(column, rowIndex);
      }

      if (e && e.target.tabIndex === -1) {
        this.focus();
      }
    }
    /**
     * Handle click event on checkbox to toggle selection of row using keyboard.
     * @param {MouseEvent} e Click event
     */

  }, {
    key: "onCheckboxClick",
    value: function onCheckboxClick(e) {
      // force selection of item in the selection view
      var _this$props2 = this.props,
          collectionView = _this$props2.collectionView,
          isHeaderRow = _this$props2.isHeaderRow;

      if (collectionView && !isHeaderRow) {
        var indexPath = collectionView.indexPathForComponent(this);
        collectionView.selectItem(indexPath, true, e.shiftKey, true);
      }
    }
  }, {
    key: "onMouseDown",
    value: function onMouseDown(event) {
      // Stop propagation on mouse down if the target is a focusable child of a cell within the row.
      // Otherwise, collection-view will try to focus the row instead.
      if (event.target.matches(_FocusManager.FOCUSABLE_ELEMENT_SELECTOR) && event.target !== this.row && !event.target.matches(CELL_SELECTOR)) {
        event.stopPropagation();
      }
    }
    /**
     * Handle key down event on a row, to navigate between focusable descendant
     * elements using the left or right arrow keys, or to navigate between the
     * header row and the body using the down or up arrow keys.
     * @param {KeyboardEvent} event A keydown event
     */

  }, {
    key: "onKeyDown",
    value: function onKeyDown(event) {
      var _this$props3 = this.props,
          tableView = _this$props3.tableView,
          _this$props3$collecti = _this$props3.collectionView,
          collectionView = _this$props3$collecti === void 0 ? tableView ? tableView.collection : null : _this$props3$collecti,
          isHeaderRow = _this$props3.isHeaderRow,
          onSelectChange = _this$props3.onSelectChange,
          onCellFocus = _this$props3.onCellFocus;
      var key = event.key;
      var focusable = null;

      switch (key) {
        case 'Tab':
          if (onCellFocus) {
            onCellFocus(null);
          }

          break;

        case 'ArrowUp':
        case 'Up':
          if (!isHeaderRow && collectionView) {
            var indexPath = collectionView.indexPathForComponent(this);

            if (indexPath && indexPath.section === 0 && indexPath.index === 0) {
              if (tableView && tableView.headerRowRef) {
                // try to focus appropriate focusedColumnIndex in the header row
                tableView.headerRowRef.focus();
              }
            }
          }

          break;

        case 'ArrowDown':
        case 'Down':
          if (isHeaderRow) {
            if (onCellFocus && (0, _closest["default"])(event.target, '.spectrum-Table-checkboxCell')) {
              onCellFocus(null);
            }

            if (collectionView) {
              focusable = collectionView.getDOMNode().querySelector(_FocusManager.FOCUSABLE_ELEMENT_SELECTOR);
            }
          } else if (collectionView) {
            var _indexPath = collectionView.indexPathForComponent(this);

            if (_indexPath && _indexPath.section === 0 && _indexPath.index === collectionView.getSectionLength(0) - 1) {
              event.preventDefault();
              event.stopPropagation();
            }
          }

          break;

        case 'a':
          if (isHeaderRow && (event.metaKey || event.ctrlKey) && onSelectChange) {
            onSelectChange(true);
            event.preventDefault();
            event.stopPropagation();
          }

          break;

        case 'Escape':
        case 'Esc':
          if (onSelectChange) {
            onSelectChange(false);
          }

          break;

        case 'Enter':
        case ' ':
          // Stop propagation on enter and space keys if the target is a focusable child of a cell within the row.
          // Otherwise, collection-view will try to focus the row instead.
          if (event.target.matches(_FocusManager.FOCUSABLE_ELEMENT_SELECTOR) && event.target !== this.row && !event.target.matches(CELL_SELECTOR)) {
            event.stopPropagation();
          }

          break;
      }

      if (focusable) {
        event.preventDefault();
        event.stopPropagation();
        focusable.focus();
      }
    }
    /**
     * Handles focus event on row, setting focused state and refreshing visible items in the collection.
     * @param {FocusEvent} event A focus event
     */

  }, {
    key: "onFocus",
    value: function onFocus(e) {
      this.setState({
        focused: true
      });

      if (e && e.target === this.row) {
        if (!this.row.contains(e.relatedTarget)) {
          // If row itself is receiving focus, call focus method to see if focus is being marshalled to a focused column
          this.focus();

          if (this.props.onFocus) {
            this.props.onFocus(e);
          }
        } else if (this.props.onCellFocus) {
          this.props.onCellFocus(null);
        }
      }
    }
    /**
     * Handles blur event on row, setting focused state and refreshing visible items in the collection.
     */

  }, {
    key: "onBlur",
    value: function onBlur() {
      this.setState({
        focused: false
      });
    }
    /**
     * Handles focus event on cell
     * @param {Number} columnIndex Index of column receiving keyboard focus
     */

  }, {
    key: "onCellFocus",
    value: function onCellFocus(columnIndex, e) {
      if (this.props.onCellFocus) {
        this.props.onCellFocus(columnIndex, e);
      }
    }
  }, {
    key: "getAriaLabelledby",
    value: function getAriaLabelledby() {
      var _this$props4 = this.props,
          columns = _this$props4.columns,
          isHeaderRow = _this$props4.isHeaderRow,
          allowsSelection = _this$props4.allowsSelection,
          _this$props4$id = _this$props4.id,
          id = _this$props4$id === void 0 ? this.rowId : _this$props4$id,
          tableId = _this$props4.tableId;
      var ariaLabelledby = null;

      if (isHeaderRow && tableId) {
        id = [tableId, 0].join('-');
      }

      ariaLabelledby = columns.map(function (column, i) {
        if (allowsSelection) {
          i += 1;
        }

        if (column.announce !== false) {
          return [[tableId, 0, i].join('-'), [id, i].join('-')].join(' ');
        }
      }).join(' ');
      return !isHeaderRow ? ariaLabelledby : null;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props5 = this.props,
          columns = _this$props5.columns,
          renderCell = _this$props5.renderCell,
          _this$props5$selected = _this$props5.selected,
          selected = _this$props5$selected === void 0 ? false : _this$props5$selected,
          _this$props5$focused = _this$props5.focused,
          focused = _this$props5$focused === void 0 ? false : _this$props5$focused,
          isHeaderRow = _this$props5.isHeaderRow,
          allowsSelection = _this$props5.allowsSelection,
          onSelectChange = _this$props5.onSelectChange,
          _this$props5$id = _this$props5.id,
          id = _this$props5$id === void 0 ? this.rowId : _this$props5$id,
          tableId = _this$props5.tableId,
          _this$props5$layoutIn = _this$props5.layoutInfo,
          layoutInfo = _this$props5$layoutIn === void 0 ? {} : _this$props5$layoutIn,
          collectionView = _this$props5.collectionView,
          allowsMultipleSelection = _this$props5.allowsMultipleSelection,
          otherProps = (0, _objectWithoutProperties2["default"])(_this$props5, ["columns", "renderCell", "selected", "focused", "isHeaderRow", "allowsSelection", "onSelectChange", "id", "tableId", "layoutInfo", "collectionView", "allowsMultipleSelection"]);
      var index = layoutInfo.index;
      var className = (0, _classnames["default"])('react-spectrum-TableView-row', {
        'spectrum-Table-head': isHeaderRow,
        'spectrum-Table-row': !isHeaderRow,
        'is-selected': selected,
        'is-focused': focused && this.state.focused,
        'is-drop-target': this.props['drop-target']
      });
      var ariaRowIndex = null;
      var tabIndex = null;
      var indeterminate = null;

      if (isHeaderRow && tableId) {
        id = [tableId, 0].join('-');
      }

      if (collectionView) {
        if (!isHeaderRow) {
          ariaRowIndex = index;

          if (ariaRowIndex !== null) {
            ariaRowIndex += 2;
          } // determine appropriate tabIndex for row depending on whether it is focused.


          tabIndex = focused || !collectionView.focusedIndexPath ? 0 : -1;
        } else {
          indeterminate = !selected && collectionView.selectedIndexPaths.length > 0;
        }
      }

      delete otherProps.onFocus;
      var checkboxCellClassNames = (0, _classnames["default"])('spectrum-Table-checkboxCell', 'react-spectrum-TableView-checkboxCell');
      return _react["default"].createElement(_FocusManager["default"], {
        itemSelector: _FocusManager.FOCUSABLE_ELEMENT_SELECTOR,
        orientation: "horizontal",
        manageTabIndex: false,
        includeSelf: true,
        ignorePageUpPageDown: true
      }, _react["default"].createElement("div", (0, _extends2["default"])({
        className: className,
        ref: function ref(row) {
          return _this2.row = row;
        },
        id: id,
        role: "row",
        tabIndex: tabIndex,
        "aria-selected": allowsSelection ? selected : null,
        "aria-rowindex": isHeaderRow ? 1 : ariaRowIndex,
        "aria-labelledby": this.getAriaLabelledby(),
        onFocus: this.onFocus,
        onBlur: this.onBlur,
        onKeyDown: this.onKeyDown,
        onMouseDown: this.onMouseDown
      }, (0, _filterDOMProps["default"])(otherProps)), allowsSelection && _react["default"].createElement(_TableCell["default"], {
        id: [id, 0].join('-'),
        isHeaderRow: isHeaderRow,
        className: checkboxCellClassNames,
        "aria-colindex": "1",
        "aria-label": isHeaderRow && allowsMultipleSelection === false ? formatMessage('Select') : null,
        tabIndex: isHeaderRow ? null : -1,
        onFocus: this.onCellFocus.bind(this, 0),
        focused: focused
      }, _react["default"].createElement(_Checkbox["default"], {
        className: "spectrum-Table-checkbox",
        checked: selected,
        indeterminate: indeterminate,
        onChange: onSelectChange,
        onClick: this.onCheckboxClick,
        onMouseDown: function onMouseDown(e) {
          return e.stopPropagation();
        },
        id: [id, 0, 'checkbox'].join('-'),
        tabIndex: isHeaderRow || focused ? 0 : -1,
        "aria-label": isHeaderRow ? formatMessage('Select All') : formatMessage('Select'),
        "aria-labelledby": !isHeaderRow ? [id, 0, 'checkbox'].join('-') + ' ' + this.getAriaLabelledby() : null,
        title: isHeaderRow ? formatMessage('Select All') : formatMessage('Select'),
        style: isHeaderRow && !allowsMultipleSelection ? {
          visibility: 'hidden'
        } : null
      })), columns.map(function (column, i) {
        return _react["default"].cloneElement(renderCell(column, i, focused), {
          key: i,
          id: [id, allowsSelection ? i + 1 : i].join('-'),
          'aria-colindex': allowsSelection ? i + 2 : i + 1,
          onClick: _this2.onCellClick.bind(_this2, column, false),
          onDoubleClick: _this2.onCellClick.bind(_this2, column, true),
          onFocus: _this2.onCellFocus.bind(_this2, allowsSelection ? i + 1 : i),
          rowFocused: focused
        });
      })));
    }
  }]);
  return TableRow;
}(_react["default"].Component), _temp)) || _class) || _class) || _class;

exports["default"] = TableRow;